export default __webpack_public_path__ + "dbe4bf316945593aa73d194414e6cfd3.png";